import PageLayout from './PageLayout';
import usePage from '../../../../hooks/use-page';

interface DoublePageProps {
  children: any;
  pagination?: boolean;
  gameLayout?: boolean;
}

const DoublePageLayout: React.FC<DoublePageProps> = ({ children, ...props }) => {
  const [{ currentPage }] = usePage();

  return (
    <>
      <PageLayout pageNumber={currentPage} {...props}>
        {children?.[0]}
      </PageLayout>
      {children?.[1] && (
        <PageLayout pageNumber={currentPage + 1} {...props}>
          {children?.[1]}
        </PageLayout>
      )}
    </>
  );
};
export default DoublePageLayout;
